"use client";

import { Alert, Snackbar } from "@mui/material";

interface ToastProps {
  open: boolean;
  onClose: () => void;
  message: string;
  anchorOrigin?: {
    vertical: "top" | "bottom";
    horizontal: "left" | "center" | "right";
  };
  autoHideDuration?: number;
  severity?: "success" | "error" | "info" | "warning";
}

export const Toast = ({
  open,
  onClose,
  message,
  anchorOrigin = { vertical: "top", horizontal: "right" },
  autoHideDuration = 5000,
  severity = "success",
}: ToastProps) => {
  return (
    <Snackbar
      open={open}
      onClose={onClose}
      autoHideDuration={autoHideDuration}
      anchorOrigin={anchorOrigin}
    >
      <Alert
        onClose={onClose}
        severity={severity}
        variant="outlined"
        sx={{ width: "100%", backgroundColor: "background.default" }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};
